<template>
  <rest-list-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :breadcrumbs="breadcrumbs"
  >
    <template slot="table">
      <rest-list-column
        v-if="selectedColumns.id"
        prop="id"
        :title="$t('Devices_Field_Id')"
        :route="rowClickDeviceIdRoute"
        :min-width="120"
      />

      <rest-list-column
        v-if="selectedColumns.profile_id"
        prop="profile_id"
        :title="$t('Devices_Field_ProfileId')"
        :route="rowClickProfileIdRoute"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.user_id && $can('UserPersonalData::Read')"
        prop="user_id"
        :title="$t('Devices_Field_UserId')"
        :min-width="120"
      />

      <rest-list-column
        v-if="selectedColumns.external_id"
        prop="external_id"
        :title="$t('Devices_Field_ExternalId')"
        :min-width="120"
      />

      <rest-list-column-enum
        v-if="selectedColumns.application"
        prop="application_id"
        :title="$t('Devices_Field_Application')"
        :enum="applications"
        :min-width="150"
        :translate="false"
      />

      <rest-list-column-enum
        v-if="selectedColumns.type"
        prop="type"
        :title="$t('Devices_Field_Type')"
        :enum="DeviceTypeLabel"
        :min-width="150"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.active"
        prop="active"
        :title="$t('Devices_Field_Active')"
        :min-width="150"
      />

      <rest-list-column-enum
        v-if="selectedColumns.environment"
        prop="environment"
        :title="$t('Devices_Field_Environment')"
        :enum="PushEnvironmentLabel"
        :min-width="150"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.addressable"
        prop="addressable"
        :title="$t('Devices_Field_Addressable')"
        :min-width="150"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.subscription"
        prop="subscription"
        :title="$t('Devices_Field_Subscription')"
        :min-width="150"
      />

      <rest-list-column
        v-if="selectedColumns.token"
        prop="token"
        :title="$t('Devices_Field_Token')"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.device_model_name"
        prop="device_model_name"
        :title="$t('Devices_Field_DeviceModelName')"
        :min-width="150"
      />

      <rest-list-column
        v-if="selectedColumns.browser"
        prop="browser"
        :title="$t('Devices_Field_Browser')"
        :min-width="150"
      />

      <rest-list-column
        v-if="selectedColumns.name"
        prop="name"
        :title="$t('Devices_Field_Name')"
        :min-width="150"
      />

      <rest-list-column
        v-if="selectedColumns.device_idfv"
        prop="device_idfv"
        :title="$t('Devices_Field_IDFV')"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.device_idfa"
        prop="device_idfa"
        :title="$t('Devices_Field_IDFA')"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.device_anid"
        prop="device_anid"
        :title="$t('Devices_Field_ANID')"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.device_adid"
        prop="device_adid"
        :title="$t('Devices_Field_ADID')"
        :min-width="300"
      />

      <rest-list-column
        v-if="selectedColumns.ga_id"
        prop="ga_id"
        :title="$t('Devices_Field_GaID')"
        :min-width="150"
      />

      <rest-list-column-date
        v-if="selectedColumns.create_time"
        prop="create_time"
        :title="$t('Devices_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column-date
        v-if="selectedColumns.deactivate_time"
        prop="deactivate_time"
        :title="$t('Devices_Field_DeactivateTime')"
        :width="200"
      />

      <rest-list-column-date
        v-if="selectedColumns.open_time"
        prop="open_time"
        :title="$t('Devices_Field_OpenTime')"
        :width="200"
      />

      <el-table-column :width="50" align="center">
        <template slot="header" slot-scope="{}">
          <rest-list-column-settings
            storage-key="devices-list-columns"
            :title="$t('Devices_Field_Settings')"
            :columns="columns"
            v-model="selectedColumns"
          />
        </template>
      </el-table-column>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPageNew'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import RestListColumnSettings from '@/common/components/rest/RestListColumnSettings'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestApi from '@/core/services/RestApi'
import { DeviceTypeLabel } from '@/modules/devices/enum/DeviceTypeEnum'
import { PushEnvironmentLabel } from '@/common/enum/PushEnvironmentEnum'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'DeviceListPage',

  components: {
    RestListColumnDate,
    RestListPage,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnBoolean,
    RestListColumnSettings
  },

  mounted() {
    this.fetchApps()
  },

  data() {
    return {
      DeviceTypeLabel,
      PushEnvironmentLabel,
      selectedColumns: {},
      applications: {}
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Users_Breadcrumb_Data')
        },
        {
          label: this.$t('Users_Breadcrumb_Devices')
        }
      ]
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `devices`,
        params: {
          sort: '-id'
        }
      })
    },

    fetchAppsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``
      })
    },

    profileIdfybyExtid() {
      return this.$store.state.app.features.profileIdfybyExtid
    },

    hasMobile() {
      return this.$store.state.app.features.mobile
    },

    hasWeb() {
      return this.$store.state.app.features.web
    },

    columns() {
      return {
        id: {
          title: this.$t('Devices_Field_Id'),
          defaultValue: true,
          validation: true
        },
        profile_id: {
          title: this.$t('Devices_Field_ProfileId'),
          defaultValue: true,
          validation: true
        },
        user_id: {
          title: this.$t('Devices_Field_UserId'),
          defaultValue: true,
          validation: this.$can('UserPersonalData::Read')
        },
        external_id: {
          title: this.$t('Devices_Field_ExternalId'),
          defaultValue: true,
          validation: !this.profileIdfybyExtid
        },
        application: {
          title: this.$t('Devices_Field_Application'),
          defaultValue: true,
          validation: true
        },
        type: {
          title: this.$t('Devices_Field_Type'),
          defaultValue: true,
          validation: true
        },
        active: {
          title: this.$t('Devices_Field_Active'),
          defaultValue: true,
          validation: true
        },
        environment: {
          title: this.$t('Devices_Field_Environment'),
          defaultValue: true,
          validation: true
        },
        addressable: {
          title: this.$t('Devices_Field_Addressable'),
          defaultValue: true,
          validation: true
        },
        subscription: {
          title: this.$t('Devices_Field_Subscription'),
          defaultValue: false,
          validation: true
        },
        token: {
          title: this.$t('Devices_Field_Token'),
          defaultValue: false,
          validation: true
        },
        device_model_name: {
          title: this.$t('Devices_Field_DeviceModelName'),
          defaultValue: false,
          validation: this.hasMobile
        },
        browser: {
          title: this.$t('Devices_Field_Browser'),
          defaultValue: false,
          validation: this.hasWeb
        },
        name: {
          title: this.$t('Devices_Field_Name'),
          defaultValue: false,
          validation: this.hasMobile
        },
        device_idfv: {
          title: this.$t('Devices_Field_IDFV'),
          defaultValue: false,
          validation: this.hasMobile
        },
        device_idfa: {
          title: this.$t('Devices_Field_IDFA'),
          defaultValue: false,
          validation: this.hasMobile
        },
        device_anid: {
          title: this.$t('Devices_Field_ANID'),
          defaultValue: false,
          validation: this.hasMobile
        },
        device_adid: {
          title: this.$t('Devices_Field_ADID'),
          defaultValue: false,
          validation: this.hasMobile
        },
        ga_id: {
          title: this.$t('Devices_Field_GaID'),
          defaultValue: false,
          validation: true
        },
        create_time: {
          title: this.$t('Devices_Field_CreateTime'),
          defaultValue: false,
          validation: true
        },
        deactivate_time: {
          title: this.$t('Devices_Field_DeactivateTime'),
          defaultValue: false,
          validation: this.hasMobile
        },
        open_time: {
          title: this.$t('Devices_Field_OpenTime'),
          defaultValue: false,
          validation: true
        }
      }
    }
  },

  methods: {
    fetchApps() {
      RestApi(this.fetchAppsEndpoint)
        .then(({ data }) => {
          let apps = []
          if (data.applications) {
            apps = data.applications.map(item => {
              return { id: item.id, name: item.name }
            })
            this.setApplications(apps)
          }
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    setApplications(applications) {
      let apps = {}
      applications.forEach(app => {
        apps[app.id] = app.name
      })
      this.applications = apps
    },

    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.id
        }
      })
    },

    rowClickProfileIdRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.profile_id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/devices/pages/DeviceListPage.vue